"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieBannerContainer = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  margin-top: 0;\n  ", ";\n  ", ";\n  max-width: unset;\n  width: 100%;\n  -webkit-text-size-adjust: 100%;\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n\n    :hover {\n      color: ", ";\n    }\n  }\n"], ["\n  flex: 1;\n  margin-top: 0;\n  ", ";\n  ", ";\n  max-width: unset;\n  width: 100%;\n  -webkit-text-size-adjust: 100%;\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n\n    :hover {\n      color: ", ";\n    }\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(80, 80, 80, 0.9);\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(80, 80, 80, 0.9);\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  max-width: 1280px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  justify-content: space-between;\n"], ["\n  max-width: 1280px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  ", ";\n  ", ";\n  ", ";\n  justify-content: space-between;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  ", ";\n  ", ";\n"], ["\n  position: absolute;\n  ", ";\n  ", ";\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 9;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.7;\n"], ["\n  position: fixed;\n  z-index: 9;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.7;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 98;\n"], ["\n  position: relative;\n  z-index: 98;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _buoyButton = require("buoy-button");

var _buoyButton2 = _interopRequireDefault(_buoyButton);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _buoyRawHtml = require("buoy-raw-html");

var _buoyRawHtml2 = _interopRequireDefault(_buoyRawHtml);

var _buoyText = require("buoy-text");

var _buoyCloseIcon = require("buoy-close-icon");

var _buoyCloseIcon2 = _interopRequireDefault(_buoyCloseIcon);

var _buoyConfig = require("buoy-config");

var _brands = require("./utils/brands");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BannerParagraph = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: "src__BannerParagraph",
  componentId: "sc-10fhjbh-0"
})(_templateObject, (0, _buoyTheme.responsive)("margin-bottom", "0", "0", "24px", "24px", "24px"), (0, _buoyTheme.responsive)("margin-right", "80px", "48px", "0", "0", "0"), _buoyTheme.colors.neutralLightest, _buoyTheme.colors.neutralLight);

var Container = _styledComponents2.default.div.withConfig({
  displayName: "src__Container",
  componentId: "sc-10fhjbh-1"
})(_templateObject2, function (props) {
  return props.hide && "\n    transition: transform 0.3s ease-out;\n    transform: translateY(100%);\n  ";
}, function (props) {
  return props.remove && "display: none;";
});

var InnerContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__InnerContainer",
  componentId: "sc-10fhjbh-2"
})(_templateObject3, (0, _buoyTheme.responsive)("flex-direction", "row", "row", "column", "column", "column"), (0, _buoyTheme.responsive)("align-items", "center", "center", "flex-end", "flex-end", "flex-end"), function (props) {
  return props.closeable ? (0, _buoyTheme.responsive)("padding", "26px 150px 26px 60px", "26px 150px 26px 60px", "46px 20px 24px", "46px 20px 24px", "46px 20px 24px") : (0, _buoyTheme.responsive)("padding", "26px 60px", "26px 60px", "24px 20px", "24px 20px", "24px 20px");
});

var CloseIconWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__CloseIconWrapper",
  componentId: "sc-10fhjbh-3"
})(_templateObject4, (0, _buoyTheme.responsive)("top", "4px", "4px", "0", "0", "0"), (0, _buoyTheme.responsive)("right", "46px", "46px", "0", "0", "0"));

var BottomBanner = function BottomBanner(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      buttonText = _ref.buttonText,
      closeable = _ref.closeable,
      hide = _ref.hide,
      remove = _ref.remove;
  return _react2.default.createElement(
    Container,
    { closeable: closeable, hide: hide, remove: remove },
    _react2.default.createElement(
      InnerContainer,
      { closeable: closeable },
      closeable && _react2.default.createElement(
        CloseIconWrapper,
        null,
        _react2.default.createElement(_buoyCloseIcon2.default, {
          onClick: onClick,
          hoverColor: "white",
          color: "neutralLightest"
        })
      ),
      _react2.default.createElement(
        BannerParagraph,
        { color: "neutralLightest", small: true },
        children
      ),
      _react2.default.createElement(
        _buoyButton2.default,
        { onClick: onClick },
        buttonText
      )
    )
  );
};

var Overlay = _styledComponents2.default.div.withConfig({
  displayName: "src__Overlay",
  componentId: "sc-10fhjbh-4"
})(_templateObject5, _buoyTheme.colors.neutralDarkest);

var CookieBannerWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__CookieBannerWrapper",
  componentId: "sc-10fhjbh-5"
})(_templateObject6);

var CookieBanner = function CookieBanner(props) {
  return _react2.default.createElement(
    CookieBannerWrapper,
    null,
    props.overlay && _react2.default.createElement(Overlay, null),
    _react2.default.createElement(
      BottomBanner,
      _extends({ buttonText: props.cta }, props),
      _react2.default.createElement(
        _buoyRawHtml2.default,
        null,
        props.text
      )
    )
  );
};

var CookieBannerContainer = function (_React$Component) {
  _inherits(CookieBannerContainer, _React$Component);

  function CookieBannerContainer() {
    _classCallCheck(this, CookieBannerContainer);

    var _this = _possibleConstructorReturn(this, (CookieBannerContainer.__proto__ || Object.getPrototypeOf(CookieBannerContainer)).call(this));

    _this.componentDidMount = function () {
      var prod = _this.props.prod === true;
      var brand = _this.props.brand || (0, _brands.getBrand)(prod);
      if (brand !== _this.state.brand) {
        _this.setState({ brand: brand });
      }
    };

    _this.onClick = function () {
      // Hide banner
      _this.setState({ hide: true });
      setTimeout(function () {
        _this.setState({ remove: true }, function () {
          if (_this.props.onClick) {
            _this.props.onClick();
          }
        });
      }, 500);
    };

    _this.state = {
      brand: null,
      hide: false,
      remove: false
    };
    return _this;
  }

  _createClass(CookieBannerContainer, [{
    key: "render",
    value: function render() {
      var brand = this.state.brand;


      if (!brand || !(brand in _buoyConfig.gdprConfig)) {
        brand = "default";
      }

      var _gdprConfig$brand = _buoyConfig.gdprConfig[brand],
          text = _gdprConfig$brand.text,
          cta = _gdprConfig$brand.cta;


      return _react2.default.createElement(CookieBanner, _extends({}, this.state, this.props, {
        cta: cta,
        text: text,
        closeable: this.props.closeable,
        overlay: this.props.overlay && !this.state.hide,
        onClick: this.onClick
      }));
    }
  }]);

  return CookieBannerContainer;
}(_react2.default.Component);

exports.default = BottomBanner;
exports.CookieBannerContainer = CookieBannerContainer;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-bottom-banner/dist/index.js
// module id = 391
// module chunks = 35783957827783